module.exports = __webpack_public_path__ + "img/4.339d1b69.webp";